/**
 * Format an amount in cents to a currency string.
 * @param amountCents - Amount in cents
 * @param currency - Currency code (e.g., "usd")
 * @returns Formatted currency string (e.g., "$12.34")
 */
export function formatCurrency(amountCents: number, currency: string): string {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: currency.toUpperCase(),
	}).format(amountCents / 100);
}

/**
 * Trigger a CSV file download in the browser.
 * @param content - CSV content as a string
 * @param filename - Name of the file to download
 */
export function downloadCSV(content: string, filename: string): void {
	const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
	const link = document.createElement("a");
	link.href = URL.createObjectURL(blob);
	link.download = filename;
	link.click();
	URL.revokeObjectURL(link.href);
}

/**
 * Escape a cell value for CSV.
 * Wraps in quotes and escapes internal quotes.
 */
function escapeCSVCell(value: unknown): string {
	const str = String(value ?? "");
	return `"${str.replace(/"/g, '""')}"`;
}

/**
 * Generate CSV content from an array of objects.
 * @param headers - Column headers in order
 * @param rows - Array of row data arrays (values in same order as headers)
 * @returns CSV content as a string
 */
export function generateCSV(headers: string[], rows: unknown[][]): string {
	return [
		headers.join(","),
		...rows.map((row) => row.map(escapeCSVCell).join(",")),
	].join("\n");
}
